import * as React from 'react'
import { type MousemoveTarget } from '../hooks/useHiddenPercent'

export function customMouseMoveHandler(
  element: HTMLDivElement,
  onMouseEnter: () => void,
  onMouseLeave: () => void,
  mousemoveTarget: MousemoveTarget,
) {
  let isMouseOverElement = false
  const handleMouseMove = (event: Pick<MouseEvent, 'clientX' | 'clientY'>) => {
    const elementAtPoint = document.elementFromPoint(event.clientX, event.clientY)
    const isMouseInNotch = element.contains(elementAtPoint) || element === elementAtPoint

    if (isMouseInNotch) {
      if (!isMouseOverElement) {
        onMouseEnter()
        isMouseOverElement = true
      }
    } else if (isMouseOverElement) {
      onMouseLeave()
      isMouseOverElement = false
    }
  }

  mousemoveTarget.addEventListener('mousemove', handleMouseMove)

  return () => {
    mousemoveTarget.removeEventListener('mousemove', handleMouseMove)
  }
}

function domEventsMouseMoveHandler(
  element: HTMLDivElement,
  onMouseEnter: () => void,
  onMouseLeave: () => void,
) {
  element.addEventListener('mouseenter', onMouseEnter)
  element.addEventListener('mouseleave', onMouseLeave)

  return () => {
    element.removeEventListener('mouseenter', onMouseEnter)
    element.removeEventListener('mouseleave', onMouseLeave)
  }
}

export function useCustomEnterLeaveMouseEvents(
  notchRef: React.RefObject<HTMLDivElement>,
  onMouseEnter: () => void,
  onMouseLeave: () => void,
  mousemoveTarget?: MousemoveTarget,
) {
  React.useEffect(() => {
    if (!notchRef.current) return

    const notchElement = notchRef.current

    if (mousemoveTarget) {
      return customMouseMoveHandler(notchElement, onMouseEnter, onMouseLeave, mousemoveTarget)
    } else {
      return domEventsMouseMoveHandler(notchElement, onMouseEnter, onMouseLeave)
    }
  }, [notchRef, mousemoveTarget])
}
